export default __webpack_public_path__ + "static/media/simbol.dda382b1.png";